import React from "react";
import UpdateOPIWeightContent from "../components/opi/update-opi-weights-content";

const UpdateOPIWeights = () => {
  return <UpdateOPIWeightContent />;
};

export default UpdateOPIWeights;
